export default "__VITE_ASSET__a4IwMzBM__"